"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Separator = exports.ORIENTATION = void 0;
var React = _interopRequireWildcard(require("react"));
var _border = require("../../styles/variables/_border");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _SeparatorModule = _interopRequireDefault(require("./Separator.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ORIENTATION = exports.ORIENTATION = Object.freeze({
  horizontal: 'horizontal',
  vertical: 'vertical'
});
const Separator = exports.Separator = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    orientation = ORIENTATION.vertical,
    width,
    height,
    testId
  } = _ref;
  // Dynamically compute width and height based on orientation if not provided
  const resolvedWidth = width || (orientation === ORIENTATION.vertical ? _border.borderWidthPrimary : 'auto');
  const resolvedHeight = height || (orientation === ORIENTATION.horizontal ? _border.borderWidthPrimary : 'auto');
  const style = {
    '--separator-width': resolvedWidth,
    '--separator-height': resolvedHeight
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: ref,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'separator'
    }),
    style: style,
    className: (0, _classify.default)(_SeparatorModule.default.wrapper, classNames?.wrapper)
  });
});